import React from "react";
import { GrNext, GrPrevious } from "react-icons/gr";

const Pagination = ({current_page, total_pages, handlePaginate}) => {
 
  return (
    <div className="pagination text-center flex justify-center items-center">
      <button
        className="btn bg-primaryColor rounded p-3 m-2 w-10"
        disabled={current_page == 1}
        onClick={() => handlePaginate(current_page - 1)}
      >
        <GrPrevious size={20} />
      </button>
      {Array.from({ length: total_pages }, (_, i) => i + 1).map((page) => (
        <button 
            key={page}
          className={`btn  rounded p-3 m-2 w-10  ${
            page == current_page ? "bg-blue-950 text-white" : "bg-primaryColor"
          }`}
          onClick={() => handlePaginate(page)}
        >
          {page}
        </button>
      ))}
      <button
        className="btn bg-primaryColor rounded p-3 m-2 w-10"
        disabled={current_page == total_pages}
        onClick={() => handlePaginate(current_page + 1)}
      >
        <GrNext size={20} />
      </button>
    </div>
  );
};

export default Pagination;
